// MeetTheTeam.jsx (or MeetTheTeam.js)
import React, { useEffect, useMemo, useState } from 'react';
import './App.css';

import neil from './assets/images/neil.png';
import phoebe from './assets/images/phoebe.png';
import becci from './assets/images/becci.png';
import emily from './assets/images/emily.png';

import banner1 from './assets/images/banner1.png';
import banner2 from './assets/images/banner2.png';
import banner3 from './assets/images/banner3.png';
import banner4 from './assets/images/banner4.png';

const AUTOPLAY_MS = 4500;

const MeetTheTeam = () => {
  const staff = useMemo(
    () => [
      {
        id: 'mgr',
        name: 'Neil Groom',
        role: 'General Manager',
        email: 'Neil@grainseed.co.uk',
        photo: neil,
        isManager: true,
      },
      {
        id: 's1',
        name: 'Phoebe Scott',
        role: 'Seed Sales Specialist',
        email: 'Phoebe@grainseed.co.uk',
        photo: phoebe,
      },
      {
        id: 's2',
        name: 'Becci Shrimpton',
        role: 'Seed Sales Specialist',
        email: 'Becci@grainseed.co.uk',
        photo: becci,
      },
      {
        id: 's3',
        name: 'Emily Pick',
        role: 'Seed Sales Specialist',
        email: 'Emily@grainseed.co.uk',
        photo: emily,
      },
    ],
    []
  );

  const gallery = useMemo(
    () => [
      { id: 'b1', src: banner1, alt: 'Banner image 1' },
      { id: 'b2', src: banner2, alt: 'Banner image 2' },
      { id: 'b3', src: banner3, alt: 'Banner image 3' },
      { id: 'b4', src: banner4, alt: 'Banner image 4' },
    ],
    []
  );

  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  const active = gallery[activeIndex];

  useEffect(() => {
    if (paused) return;

    const t = setInterval(() => {
      setActiveIndex((i) => (i + 1) % gallery.length);
    }, AUTOPLAY_MS);

    return () => clearInterval(t);
  }, [paused, gallery.length]);

  const manager = staff.find((s) => s.isManager);
  const team = staff.filter((s) => !s.isManager);

  return (
    <div className="meet-the-team-container">
      <header className="mtt-header">
        <h1>Meet the Team</h1>
        <p>
          We have a knowledgeable, friendly team that can help and advise you on what’s best for your
          farm. We work with all the major seed breeders in the UK to offer you the best options.
        </p>
      </header>

      <section className="mtt-profiles" aria-label="Staff profiles">
        {manager && (
          <article className="mtt-card mtt-card--manager">
            <img className="mtt-avatar" src={manager.photo} alt={`${manager.name} profile`} />
            <div className="mtt-card__body">
              <div className="mtt-name">{manager.name}</div>
              <div className="mtt-role">{manager.role}</div>
              <a className="mtt-email" href={`mailto:${manager.email}`}>
                {manager.email}
              </a>
            </div>
          </article>
        )}

        <div className="mtt-team-grid">
          {team.map((member) => (
            <article key={member.id} className="mtt-card">
              <img className="mtt-avatar" src={member.photo} alt={`${member.name} profile`} />
              <div className="mtt-card__body">
                <div className="mtt-name">{member.name}</div>
                <div className="mtt-role">{member.role}</div>
                <a className="mtt-email" href={`mailto:${member.email}`}>
                  {member.email}
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section
        className="mtt-gallery"
        aria-label="Image gallery"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div className="mtt-gallery__main" tabIndex={0} onFocus={() => setPaused(true)} onBlur={() => setPaused(false)}>
          <img key={active.id} src={active.src} alt={active.alt} className="mtt-gallery__mainImage" />
        </div>

        <div className="mtt-gallery__thumbs" role="tablist" aria-label="Select an image">
          {gallery.map((img, idx) => {
            const isActive = idx === activeIndex;
            return (
              <button
                key={img.id}
                type="button"
                className={`mtt-thumb ${isActive ? 'is-active' : ''}`}
                onClick={() => setActiveIndex(idx)}
                aria-pressed={isActive}
                aria-label={`Show image ${idx + 1}`}
              >
                <img src={img.src} alt="" className="mtt-thumb__img" />
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default MeetTheTeam;
